import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { sendAmplitude_Default } from '@common/utils';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { inject } from 'mobx-react';
import { observer } from "mobx-react-lite";
import { Loader, Button } from 'oned';
import { withRouter } from 'react-router-dom';
var HowToVideoMobile = inject(ProblemBusiness)(observer(function (props) {
    var videoURL = props.videoURL, problemCaseCadeName = props.problemCaseCadeName, videoTitle = props.videoTitle, setHowToVideoVisible = props.setHowToVideoVisible, thenAction = props.thenAction, howToVideoCreateCancelWO = props.howToVideoCreateCancelWO, history = props.history;
    var _a = useState(false), playing = _a[0], setPlaying = _a[1];
    var _b = useState(0), count = _b[0], setCount = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var getFormateSVC = function () {
        return problemCaseCadeName === null || problemCaseCadeName === void 0 ? void 0 : problemCaseCadeName.replace(/ > /g, ' -> ');
    };
    var sendWatchTimeAmplitude = function () {
        sendAmplitude_Default("Maintenance_Howtovideos_watchtime", { Time: count + " seconds" });
    };
    useEffect(function () {
        sendAmplitude_Default("Maintenance_howtovideos", { SVC: getFormateSVC() });
    }, []);
    useEffect(function () {
        var timer;
        if (playing) {
            timer = setInterval(function () {
                setCount(function (prevCount) { return prevCount + 1; });
            }, 1000);
        }
        else if (timer) {
            clearInterval(timer);
            timer = null;
        }
        return function () { return clearInterval(timer); };
    }, [playing]);
    var handlePause = function () {
        setPlaying(false);
        sendAmplitude_Default("Maintenance_Howtovideos_pause", { SVC: getFormateSVC() });
    };
    var handlePlay = function () {
        setPlaying(true);
        sendAmplitude_Default("Maintenance_Howtovideos_play", { SVC: getFormateSVC() });
    };
    var handleOk = function () {
        sendAmplitude_Default("Maintenance_Howtovideos_continuecreation", { SVC: getFormateSVC() });
        sendWatchTimeAmplitude();
        setHowToVideoVisible(false);
        thenAction();
    };
    var handleCancel = function () {
        setLoading(true);
        setPlaying(false);
        sendAmplitude_Default("Maintenance_Howtovideos_isolvedmyself", { SVC: getFormateSVC() });
        sendWatchTimeAmplitude();
        setHowToVideoVisible(false);
        howToVideoCreateCancelWO().then(function (data) {
            history.push("/?isFromNewRequestSubmitted=true");
        }).catch(function (error) {
            window.notificationManager.show({
                title: "Warning!",
                type: "primary",
                position: "top-right",
                content: "Something was wrong, please try later!",
            });
        }).finally(function () {
            setLoading(false);
        });
    };
    var getButtonHeight = function () {
        var basicHeight = (document.body.clientHeight - 420);
        return basicHeight < 120 ? "20px" : basicHeight - 130 + "px";
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Loader, { page: true, visible: loading }),
        React.createElement(ReactPlayer, { controls: true, url: videoURL, height: "215px", width: "100%", onPlay: handlePlay, onPause: handlePause, playing: playing }),
        React.createElement("div", { style: { fontSize: '16px', fontWeight: 700, marginTop: '20px' } }, videoTitle),
        React.createElement("div", { style: { fontSize: '14px' } }, "We have a how to video for this scenario. Watch it and determine if this can solve your issue."),
        React.createElement("div", { style: { marginTop: getButtonHeight() } },
            React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement("a", { onClick: handleCancel, style: { fontSize: '14px' } }, "I solved the issue myself")),
            React.createElement("div", { style: { textAlign: 'center', marginTop: '15px' } },
                React.createElement(Button, { type: 'primary', onClick: handleOk, className: "dsm-btn dsm-btn-primary dsm-btn-normal dsm-btn-block f14" }, "Continue Maintenance Request")))));
}));
export default withRouter(HowToVideoMobile);
